import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const friendLinks = [
  { label: "创作者中心", href: "#" },
  { label: "内容规范", href: "#" },
  { label: "帮助与反馈", href: "#" },
  { label: "加入我们", href: "#" },
  { label: "隐私政策", href: "#" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200 mt-16">
      <div className="px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-extrabold text-lg text-foreground-950">呱呱视频社区</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              多元视频分享与互动平台，汇聚短视频、娱乐与生活内容，让每一次观看都有惊喜。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-3">
              <Link to="/" className="hover:text-primary-600">内容分类</Link>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-600">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-3">
              <Link to="/upload" className="hover:text-primary-600">参与社区</Link>
            </h4>
            <ul className="space-y-2">
              <li><Link to="/upload" className="text-sm text-foreground-600 hover:text-primary-600">上传视频</Link></li>
              <li><Link to="/search" className="text-sm text-foreground-600 hover:text-primary-600">搜索内容</Link></li>
              <li><Link to="/profile" className="text-sm text-foreground-600 hover:text-primary-600">个人中心</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-3">友情链接</h4>
            <ul className="flex flex-wrap gap-x-4 gap-y-2">
              {friendLinks.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-foreground-600 hover:text-primary-600">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 呱呱视频社区 · 本站为前端演示项目，视频内容均为示意数据
          </p>
          <p className="text-xs text-foreground-500">用心分享，快乐互动</p>
        </div>
      </div>
    </footer>
  );
}